import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";

export default function Footer() {
    return (
        <footer className="relative bg-wine-dark text-cream pt-24 pb-10 mt-32 overflow-hidden">
            <div className="relative container-edge grid grid-cols-1 md:grid-cols-4 gap-12">
                <div>
                    <img
                        src="https://customer-assets.emergentagent.com/job_curated-pt/artifacts/uc0zysi5_c8drzsa3_logo3_dark_badge-removebg-preview%20%281%29.png"
                        alt="O Caseirinho"
                        className="h-32 w-auto object-contain"
                    />
                    <p className="mt-4 text-sm text-cream/70 leading-relaxed">
                        Marketplace premium de vinhos e produtos artesanais portugueses. Direto de
                        quem faz, para a sua mesa.
                    </p>
                </div>
                <div>
                    <h4 className="label-overline text-gold-soft">Marketplace</h4>
                    <ul className="mt-6 space-y-3 text-sm">
                        <li><Link to="/marketplace?category=Vinho Tinto" className="hover:text-gold-soft transition-colors">Vinhos Tintos</Link></li>
                        <li><Link to="/marketplace?category=Vinho Branco" className="hover:text-gold-soft transition-colors">Vinhos Brancos</Link></li>
                        <li><Link to="/marketplace?category=Azeite" className="hover:text-gold-soft transition-colors">Azeites</Link></li>
                        <li><Link to="/marketplace?category=Queijos" className="hover:text-gold-soft transition-colors">Queijos</Link></li>
                        <li><Link to="/marketplace?category=Compotas" className="hover:text-gold-soft transition-colors">Compotas</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="label-overline text-gold-soft">Caseirinho</h4>
                    <ul className="mt-6 space-y-3 text-sm">
                        <li><Link to="/produtores" className="hover:text-gold-soft transition-colors">Produtores</Link></li>
                        <li><Link to="/clube" className="hover:text-gold-soft transition-colors">Clube Caseirinho</Link></li>
                        <li><Link to="/blog" className="hover:text-gold-soft transition-colors">Diário</Link></li>
                        <li><Link to="/register?role=vendor" className="hover:text-gold-soft transition-colors">Vender connosco</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="label-overline text-gold-soft">Contacto</h4>
                    <p className="mt-6 text-sm text-cream/70">
                        Rua das Vinhas, 12<br />
                        1200-001 Lisboa<br />
                        Portugal
                    </p>
                    <div className="mt-6 flex items-center gap-5">
                        <a href="#" aria-label="Instagram" className="hover:text-gold-soft transition-colors">
                            <Instagram className="h-5 w-5" strokeWidth={1.5} />
                        </a>
                        <a href="#" aria-label="Facebook" className="hover:text-gold-soft transition-colors">
                            <Facebook className="h-5 w-5" strokeWidth={1.5} />
                        </a>
                        <a href="mailto:ola@caseirinho.pt" className="hover:text-gold-soft transition-colors">
                            <Mail className="h-5 w-5" strokeWidth={1.5} />
                        </a>
                    </div>
                </div>
            </div>
            <div className="relative container-edge mt-16 pt-8 border-t border-cream/10 flex flex-col md:flex-row gap-4 items-center justify-between text-xs text-cream/50">
                <span>© {new Date().getFullYear()} Caseirinho.pt — Todos os direitos reservados.</span>
                <span>Beba com moderação. Venda apenas a maiores de 18.</span>
            </div>
        </footer>
    );
}
